import api from "./../api";
/* eslint-disable */
export default {
  namespaced: true,
  state: {
    items: [],
    total: 0,
    page: 1,
    pageSize: 20,
  },
  getters: {
    getWelcomeBalanceTransactions(state) {
      return state.items;
    },
    getWelcomeBalanceTotal(state) {
      return state.total;
    },
    getWelcomeBalancePage(state) {
      return state.page;
    },
    getWelcomeBalancePageSize(state) {
      return state.pageSize;
    },
  },
  mutations: {
    setWelcomeBalanceTransactions(state, payload) {
      state.items = payload.items || [];
      state.total = payload.total || 0;
      state.page = payload.page || 1;
      state.pageSize = payload.pageSize || state.pageSize;
    },
  },
  actions: {
    fetchAll({ commit, state }, data) {
      return new Promise((resolve, rej) => {
        const body = {
          page: data?.page || state.page,
          pageSize: data?.pageSize || state.pageSize,
          searchText: data?.searchText || null,
        };
        api()
          .post(`welcomeBalanceTransactions/listAll`, body, {
            headers: {
              Authorization: localStorage.getItem("JwtToken"),
            },
          })
          .then((res) => {
            commit("setWelcomeBalanceTransactions", {
              items: res.data.items || [],
              total: res.data.total || 0,
              page: res.data.page || body.page,
              pageSize: res.data.pageSize || body.pageSize,
            });
            resolve(res);
          })
          .catch((err) => {
            console.log(err);
            rej(err);
          });
      });
    },
    fetchByPerson({ commit, state }, data) {
      return new Promise((resolve, rej) => {
        const body = {
          personId: data.personId,
          page: data.page || state.page,
          pageSize: data.pageSize || state.pageSize,
        };
        api()
          .post(`welcomeBalanceTransactions/listByPerson`, body, {
            headers: {
              Authorization: localStorage.getItem("JwtToken"),
            },
          })
          .then((res) => {
            commit("setWelcomeBalanceTransactions", {
              items: res.data.items || [],
              total: res.data.total || 0,
              page: res.data.page || body.page,
              pageSize: res.data.pageSize || body.pageSize,
            });
            resolve(res);
          })
          .catch((err) => {
            console.log(err);
            rej(err);
          });
      });
    },
    add({ dispatch }, data) {
      return new Promise((resolve, rej) => {
        api()
          .post(`welcomeBalanceTransactions/add`, data, {
            headers: {
              Authorization: localStorage.getItem("JwtToken"),
            },
          })
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            console.log(err);
            rej(err);
          });
      });
    },
  },
};


